import { ReadingType } from "@/History"

export enum OtherSensorOutput {
    DRY_BULB = "dryBulb",
    WET_BULB = "wetBulb",
    RH = "RH"
}

export type SensorOutputType = ReadingType | OtherSensorOutput